import styled from 'styled-components';

import { theme } from '../ui/theme';

export const Table = styled.table`
    width: 100%;
    max-width: 100%;

    > thead > tr > th {
        padding: ${theme.space[12]};
        vertical-align: middle;
        text-align: left;
        font-weight: ${theme.fontWeights[600]};
        color: ${theme.colors.foreground.muted};
    }

    > tbody > tr > td {
        border-top: 1px solid ${theme.colors.border.muted};
        padding: ${theme.space[12]};
        vertical-align: middle;

        small {
            color: ${theme.colors.foreground.muted};
        }
    }

    > tbody > tr > td {
        font-weight: ${theme.fontWeights[400]};
    }

    > tfoot tr {
        border-top: 1px solid ${theme.colors.border.muted};
        border-bottom: 1px solid ${theme.colors.border.muted};
    }
`;
